import React, { useEffect } from "react";
import "../../../assets/css/patient/Terms.css";
import MyNavbar from "../../../components/general/navbar/MyNavbar";
import Footer from "../../../components/general/footer/Footer";

// Har section yahan ek object hai — naya section add karna ho to bas array mein add karo
const sections = [
  {
    title: "Use of Our Platform",
    body: "You agree to use SpeechTherapy only for lawful purposes and to provide accurate information when creating an account or communicating with our AI assistant or therapists. You are responsible for keeping your account credentials secure.",
  },
  {
    title: "Not a Substitute for Medical Advice",
    body: "Our AI-powered guidance is intended to support and complement speech therapy, not replace professional medical diagnosis or treatment. Always consult a licensed therapist or physician for serious or worsening symptoms.",
  },
  {
    title: "Therapist Interactions",
    body: "Therapists registered on our platform are independent professionals. SpeechTherapy facilitates the connection between patients and therapists but is not responsible for the outcome of individual therapy sessions.",
  },
  {
    title: "Subscriptions & Payments",
    body: "Paid plans are billed on a recurring basis as described on our Pricing page. You may cancel your subscription at any time; access will continue until the end of the current billing period.",
  },
  {
    title: "Account Termination",
    body: "We reserve the right to suspend or terminate accounts that violate these terms, misuse the platform, or provide false information.",
  },
  {
    title: "Changes to These Terms",
    body: "We may update these Terms & Conditions from time to time. Continued use of the platform after changes means you accept the updated terms.",
  },
];

function Terms() {
  // Page khulte hi scroll top pe le jao — jaisa Home/About/Blog mein hota hai
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <MyNavbar />

      <section className="terms">
        <div className="terms-header">
          <span className="terms-eyebrow">Legal</span>
          <h1>Terms &amp; Conditions</h1>
          <p className="last-updated">Last updated: August 2026</p>
          <p className="terms-intro">
            Welcome to SpeechTherapy. By creating an account or using our
            platform, you agree to the following terms. Please read them
            carefully before using our services.
          </p>
        </div>

        <div className="terms-body">
          {sections.map((section, index) => (
            <div className="terms-section" key={section.title}>
              <span className="section-number">
                {String(index + 1).padStart(2, "0")}
              </span>
              <div>
                <h2>{section.title}</h2>
                <p>{section.body}</p>
              </div>
            </div>
          ))}

          <div className="terms-section">
            <span className="section-number">07</span>
            <div>
              <h2>Contact Us</h2>
              <p>
                If you have questions about these terms, reach out to us at{" "}
                <a href="mailto:support@speechtherapy.ai">
                  support@speechtherapy.ai
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Terms;